function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "swap_horizontal_circle",
  clipPath: "url(#clip0_2524_955)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M41.819 7.63995C22.959 7.63995 7.65234 22.9466 7.65234 41.8066C7.65234 60.6666 22.959 75.9733 41.819 75.9733C60.679 75.9733 75.9857 60.6666 75.9857 41.8066C75.9857 22.9466 60.679 7.63995 41.819 7.63995ZM41.819 69.1399C26.7515 69.1399 14.4857 56.8741 14.4857 41.8066C14.4857 26.7391 26.7515 14.4733 41.819 14.4733C56.8865 14.4733 69.1523 26.7391 69.1523 41.8066C69.1523 56.8741 56.8865 69.1399 41.819 69.1399ZM52.069 23.015V31.5566H38.4023V38.39H52.069V46.9316L64.0273 34.9733L52.069 23.015ZM31.569 36.6816L19.6107 48.64L31.569 60.5983V52.0566H45.2357V45.2233H31.569V36.6816Z",
  fill: "#373435"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2524_955"
}, /*#__PURE__*/React.createElement("rect", {
  width: 82,
  height: 82,
  fill: "white",
  transform: "translate(0.819336 0.806641)"
})));

function SvgSwapHorizontalCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapHorizontalCircle);
export default __webpack_public_path__ + "static/media/swap_horizontal_circle.1e5c45f0.svg";
export { ForwardRef as ReactComponent };